import Choices from 'choices.js';

class CornerHeading {
  constructor() {
    this._init();
  }

  _init() {
    const form = document.querySelector<HTMLFormElement>(
      '[data-corner-heading-form]'
    );
    if (!form) return;

    // Selects
    const selects = document.querySelectorAll(
      '[data-corner-heading-select]'
    ) as NodeListOf<HTMLSelectElement>;
    if (selects) {
      selects.forEach(select => {
        new Choices(select, {
          searchEnabled: false,
          searchChoices: false,
          itemSelectText: '',
        });

        select.addEventListener('change', event => {
          const url = new URL(window.location.href);

          // 2. On nettoie TOUTE trace de pagination à la fin du chemin
          // Supprime "/page/2", "/page/2/", ou juste "/2" si c'était le cas
          // La regex : cherche "/page/" suivi de chiffres OU un slash suivi de chiffres en fin de chaîne
          url.pathname = url.pathname
            .replace(/\/page\/\d+\/?$/, '/')
            .replace(/\/(\d+)\/?$/, '/');

          // 3. On s'assure que le chemin se termine proprement par un seul slash
          if (!url.pathname.endsWith('/')) {
            url.pathname += '/';
          }

          // 4. On met à jour l'action du formulaire et on soumet
          form.action = url.pathname;

          form.submit();
        });
      });
    }
  }
}

export const cornerHeading = new CornerHeading();
